import React from 'react';
import { Box, Container, Typography, Link, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';

const Footer = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        py: 3, 
        mt: 'auto',
        backgroundColor: '#0f172a',
        color: 'white',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)'
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: { xs: 2, sm: 3 }
        }}>
          <Link 
            component={RouterLink} 
            to="/" 
            sx={{ 
              color: 'white', 
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Home
          </Link>
          <Typography sx={{ color: 'rgba(255,255,255,0.5)' }}>|</Typography>
          <Link 
            component={RouterLink} 
            to="/about" 
            sx={{ 
              color: 'white', 
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            About
          </Link>
          <Typography sx={{ color: 'rgba(255,255,255,0.5)' }}>|</Typography>
          <Link 
            component={RouterLink} 
            to="/contact" 
            sx={{ 
              color: 'white', 
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Contact
          </Link>
          <Typography sx={{ color: 'rgba(255,255,255,0.5)' }}>|</Typography>
          <Link 
            component={RouterLink} 
            to="/privacy" 
            sx={{ 
              color: 'white', 
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Privacy
          </Link>
        </Box>
        <Typography 
          variant="body2" 
          align="center" 
          sx={{ 
            mt: 2,
            color: 'rgba(255, 255, 255, 0.6)'
          }}
        >
          © {new Date().getFullYear()} Stack Track. All rights reserved.
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} Poker Range Trainer
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Link
              href="https://instagram.com/pokerrangetrainer"
              target="_blank"
              rel="noopener"
              color="inherit"
              sx={{ 
                display: 'flex', 
                alignItems: 'center',
                '&:hover': { 
                  color: '#E1306C' // Instagram brand color
                }
              }}
            >
              <InstagramIcon />
            </Link>
            <Link
              href="https://facebook.com/pokerrangetrainer"
              target="_blank"
              rel="noopener"
              color="inherit"
              sx={{ 
                display: 'flex', 
                alignItems: 'center',
                '&:hover': { 
                  color: '#4267B2' // Facebook brand color
                }
              }}
            >
              <FacebookIcon />
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 